import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a713696"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-my-3 p-px-3" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex custom-text-center"
}
const _hoisted_3 = { class: "mx-auto" }
const _hoisted_4 = { class: "p-p-3 shadow bg-color-secondary rounded" }
const _hoisted_5 = { class: "p-d-flex p-jc-between p-mb-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "รายละเอียดการชำระเงิน")
], -1))
const _hoisted_7 = { class: "p-my-2" }
const _hoisted_8 = { class: "p-d-flex p-jc-between p-mb-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "จำนวนเงิน")
], -1))
const _hoisted_10 = {
  key: 0,
  class: ""
}
const _hoisted_11 = {
  key: 1,
  class: ""
}
const _hoisted_12 = {
  key: 0,
  class: "p-d-flex p-jc-between p-mb-2"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
  /*#__PURE__*/_createElementVNode("span", null, "หลังฐานการโอน")
], -1))
const _hoisted_14 = { class: "w-90" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "p-d-flex p-jc-between p-mb-2" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ช่องทางการชำระเงิน", -1))
const _hoisted_22 = { class: "p-d-flex p-jc-between p-mb-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "สถานะการชำระเงิน", -1))
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { class: "p-text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.transaction.reasonId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, "เหตุผล : " + _toDisplayString(_ctx.reasonRejectList.reasonList?.find((it) => it.id == _ctx.transaction.reasonId)?.name), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("u", {
            class: "pointer f-size-14 text-gray-1",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onBackToSelectPaymentMethode && _ctx.onBackToSelectPaymentMethode(...args)))
          }, "เปลี่ยนช่องทางการชำระเงิน")
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", null, [
          (_ctx.transferSlip && _ctx.transferSlip.amount !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$filters.formatNumber(_ctx.transferSlip.amount)) + " บาท ", 1))
            : (_ctx.transaction && _ctx.transaction.grandTotal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$filters.formatNumber(_ctx.transaction.grandTotal)) + " บาท ", 1))
              : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.transaction.paymentMethodId == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              (_ctx.transferSlip.imageList.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transferSlip.imageList, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index + 'fileupload'
                      }, [
                        _createElementVNode("img", {
                          class: "m-1",
                          src: item.imageUrl,
                          style: {"height":"auto","width":"100%"},
                          alt: ""
                        }, null, 8, _hoisted_16),
                        _hoisted_17
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_18, "-"))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.transaction.paymentMethodId !== 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", null, _toDisplayString(_ctx.transaction.paymentName), 1)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", null, [
                (_ctx.transaction.statusId == 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, "ดำเนินการชำระเงินสำเร็จ"))
                  : _createCommentVNode("", true),
                (_ctx.transaction.statusId == 8)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, " ดำเนินการชำระเงินไม่สำเร็จ "))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.transaction.paymentMethodId == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", {
                class: _normalizeClass(["textc-primary f-size-14 p-mt-2", { 'payment-fail': _ctx.transaction.statusId === 8 }])
              }, [
                _createElementVNode("u", {
                  class: "pointer text-gray-1 f-size-14",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleChangePaymentProove()))
                }, "แก้ไขหลักฐานการชำระเงิน")
              ], 2)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}